module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Reset password","resetPassword":"Change password"},"ru":{"title":"Восстановление пароля","resetPassword":"Изменить пароль"}}')
  delete Component.options._Ctor
}
